// Single source of truth for phone handling (Israeli numbers). Every number
// shown or sent anywhere should pass through here — never display a raw value.

export function normalizePhone(raw: string | null | undefined): string {
  const digits = (raw ?? '').replace(/\D/g, '')
  if (digits.startsWith('972')) return digits
  if (digits.startsWith('0'))   return '972' + digits.slice(1)
  if (digits.length === 9)      return '972' + digits
  return digits
}

// Human-friendly display: 050-123-4567. Falls back to the raw input when it
// isn't a recognisable Israeli mobile.
export function prettyPhone(raw: string | null | undefined): string {
  if (!raw) return '—'
  const n = normalizePhone(raw)
  if (n.startsWith('972') && n.length === 12) {
    const local = '0' + n.slice(3) // 0501234567
    return `${local.slice(0, 3)}-${local.slice(3, 6)}-${local.slice(6)}`
  }
  return raw
}

// wa.me deep link for starting a WhatsApp conversation, or null if unusable.
export function waLink(raw: string | null | undefined): string | null {
  const n = normalizePhone(raw)
  return n ? `https://wa.me/${n}` : null
}
